<template>
  <v-container>
    <v-row>
      <v-col>
        <exo-input-select :root="_self" name="frame" />
      </v-col>
      <v-col><exo-input-date-time :root="_self" name="burnStartDate" /></v-col>
    </v-row>
    <v-row>
      <v-col><exo-input-double :root="_self" name="deltaVAlongXAxis" /></v-col>
      <v-col><exo-input-double :root="_self" name="deltaVAlongYAxis" /></v-col>
      <v-col><exo-input-double :root="_self" name="deltaVAlongZAxis" /></v-col>
    </v-row>
    <v-row v-if="isBurnZero"
      ><span class="error--text">A burn total ΔV cannot be 0</span></v-row
    >
  </v-container>
</template>

<script>
import axios from '../../services/axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import dataTools from '../../tools/data.js'
Vue.use(VueAxios, axios)
import { v4 as uuid } from 'uuid'
import fieldsDescription from '../../tools/fieldsDescription.json'

export default {
  name: 'CustomBurnForm',

  mixins: [errorMixin, formMixin, numericalMixin],

  props: {
    customBurn: {
      type: Object,
      default: () => null
    },
    spaceObject: {
      type: Object,
      default: () => null
    }
  },

  created() {},

  mounted() {
    this.init()
  },

  watch: {
    customBurn: {
      handler() {
        if (this.customBurn != null) {
          this.copyLocalFields(this.customBurn)
        }
      },
      deep: true
    },
    isValid: {
      handler(newValue) {
        this.$emit('updateValid', newValue)
        if (newValue === true) {
          this.update()
        }
      },
      immediate: true
    },
    inputs: {
      handler() {
        this.update()
      },
      deep: true
    },
    spaceObject: {
      handler(newValue) {
        this.inputs.spaceObject = newValue
      },
      deep: true
    }
  },

  data() {
    return {
      enableFormCache: false,
      dialog: false,
      enumPropertiesList: this.getEnumProperties(),
      inputs: {
        name: uuid(),
        spaceObject: this.getDefaultValue('spaceObject'),
        frame: this.getDefaultValue('frame'),
        burnStartDate: this.getDefaultValue('burnStartDate'),
        deltaVAlongXAxis: this.getDefaultValue('deltaVAlongXAxis'),
        deltaVAlongYAxis: this.getDefaultValue('deltaVAlongYAxis'),
        deltaVAlongZAxis: this.getDefaultValue('deltaVAlongZAxis')
      }
    }
  },

  computed: {
    allPropertiesList() {
      return [
        ...this.getOptionalPropertiesList(this.inputs),
        ...this.getRequiredPropertiesList(this.inputs)
      ]
    },
    isBurnZero() {
      return (
        parseFloat(this.inputs.deltaVAlongXAxis) *
          parseFloat(this.inputs.deltaVAlongXAxis) +
          parseFloat(this.inputs.deltaVAlongYAxis) *
            parseFloat(this.inputs.deltaVAlongYAxis) +
          parseFloat(this.inputs.deltaVAlongZAxis) *
            parseFloat(this.inputs.deltaVAlongZAxis) ===
        0
      )
    },
    isValid() {
      return this.inputsValid && !this.isBurnZero
    }
  },

  methods: {
    openDialogHandler() {},
    refreshTable() {},
    getCurrentFormType() {
      return 'CustomBurnDefinition'
    },
    getSubTypes(instance) {
      return null
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },
    update() {
      const newValue = {
        ...this.customBurn,
        ...this.createObjectFromForm()
      }
      this.$emit('updateCustomBurn', newValue)
    },
    init() {
      if (this.customBurn != null) {
        this.copyLocalFields(this.customBurn)
        this.fillMissingDefaultValueInInputs()
      }
      if (this.customBurn.id != null) {
        this.inputs.id = this.customBurn.id
      } else {
        this.inputs.id = uuid()
      }
      if (this.customBurn.name != null) {
        this.inputs.name = this.customBurn.name
      } else {
        this.inputs.name = uuid()
      }
      if (this.spaceObject != null) {
        this.inputs.spaceObject = this.spaceObject
      }
    }
  }
}
</script>

<style scoped></style>
